// extracted by mini-css-extract-plugin
export default {"container":"aE-z","dimension":"bE-z","dimensionLabels":"cE-z"};